import { baseApi, PaginatedResponse } from 'sama-shared';
import type { GetSubscriptionPlansParams } from '../../types/api';
import type { SubscriptionPlan, SubscriptionPlanWithPermissions } from './types/subscription-plan';

export const subscriptionPlanApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getActiveSubscriptionPlan: builder.query<
      PaginatedResponse<SubscriptionPlan>,
      GetSubscriptionPlansParams
    >({
      query: (params) => ({
        url: '/admin/subscription-plan',
        method: 'GET',
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map(({ id }) => ({ type: 'SubscriptionPlan' as const, id })),
              { type: 'SubscriptionPlan', id: 'LIST' },
            ]
          : [{ type: 'SubscriptionPlan', id: 'LIST' }],
    }),

    getSubscriptionPlanById: builder.query<SubscriptionPlanWithPermissions, string>({
      query: (id) => ({
        url: `/admin/subscription-plan/${id}`,
        method: 'GET',
      }),
      providesTags: (_result, _error, id) => [{ type: 'SubscriptionPlan', id }],
    }),

    createSubscriptionPlan: builder.mutation<SubscriptionPlan, Partial<SubscriptionPlan>>({
      query: (body) => ({
        url: '/admin/subscription-plan',
        method: 'POST',
        body,
      }),
      invalidatesTags: [{ type: 'SubscriptionPlan', id: 'LIST' }],
    }),

    updateSubscriptionPlan: builder.mutation<
      SubscriptionPlan,
      { id: string; body: Partial<SubscriptionPlan> }
    >({
      query: ({ id, body }) => ({
        url: `/admin/subscription-plan/${id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: (_result, _error, { id }) => [
        { type: 'SubscriptionPlan', id },
        { type: 'SubscriptionPlan', id: 'LIST' },
      ],
    }),
  }),

  overrideExisting: false,
});

export const {
  useGetActiveSubscriptionPlanQuery,
  useUpdateSubscriptionPlanMutation,
  useCreateSubscriptionPlanMutation,
  useGetSubscriptionPlanByIdQuery,
  useLazyGetSubscriptionPlanByIdQuery,
} = subscriptionPlanApi;
